import { ApiProperty } from "@nestjs/swagger";

export class EmployeeByUnitRequest{
  @ApiProperty()
  unitId: number;

  @ApiProperty()
  screen: string;

}